export default __webpack_public_path__ + "static/media/(24).6736ff8c.jpg";